import { render, staticRenderFns } from "./BuyCertificate.vue?vue&type=template&id=72aef465"
import script from "./BuyCertificate.vue?vue&type=script&lang=js"
export * from "./BuyCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports